import gql from "graphql-tag";

export const CREATE_TODOIST_TASK = gql`
  mutation ($input: createTodoistTaskInput) {
    createTodoistTask(input: $input)
  }
`;
